const strip = (s: string) => s.replace(/\/$/, "");
export const BIZ = strip(import.meta.env.VITE_BIZ_API_URL || "/api/business");
export const PLATFORM = `${BIZ}/platform`;
export const MGMT = `${BIZ}/mgmt`;
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || "";
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || "";
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || "";
